@let routeData = routeData$ | async;
@if (routeData !== null && routeData !== undefined) {
  <bit-header
    [title]="title() || (routeData.titleId ? (routeData.titleId | i18n) : '')"
    [icon]="icon()"
    [backRouterLink]="backRouterLink() || routeData.backRouterLink"
  >
    <ng-container slot="breadcrumbs">
      <ng-content select="[slot=breadcrumbs]"></ng-content>
    </ng-container>

    <ng-content></ng-content>
    <product-switcher></product-switcher>
    <app-account-menu></app-account-menu>

    <ng-container slot="title-suffix">
      <ng-content select="[slot=title-suffix]"></ng-content>
    </ng-container>

    <ng-container slot="secondary">
      <ng-content select="[slot=secondary]"></ng-content>
    </ng-container>

    <ng-container slot="tabs">
      <ng-content select="[slot=tabs]"></ng-content>
    </ng-container>
  </bit-header>
}
